export default (candidate = false) => {
  let tokenLocation = "user.token";
  if (candidate == true || candidate == 1) {
    tokenLocation = "candidate.token";
  }
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem(tokenLocation),
    },
  };
};
